import i18n from '@/i18n';

export default [
  {
    path: '/internal-users',
    name: 'internal-users',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      // TODO new permissions
      permissions: [
        {
          subject: 'user',
          actions: ['view-nav-link', 'view'],
        },
      ],
      title: i18n.global.t('internal_users')
    },
    // route level code-splitting
    component: () => import('../../views/internalUsers/Index.vue'),
    children: [
      {
        path: 'new',
        name: 'internal-users-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'user',
              actions: ['store'],
            },
          ],
          title: i18n.global.t('internal_users'),
        },
        component: () => import('../../views/users/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'internal-users-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'user',
              actions: ['update'],
            },
          ],
          title: i18n.global.t('internal_users'),
        },
        component: () => import('../../views/users/Edit.vue'),
      },
    ],
  },
];
